import { Button, Form, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../utils/eventEmitter';


const MyFooter = ({ handleSell, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSell} type='primary'>Sell</Button>
      <Button onClick={handleCancel} danger>Cancel</Button>
    </div>
  )
};

const action = [{ value: 'sell', label: 'Sell'}, {value: 'dispose', label: 'Dispose'}];

const SellOrDispose = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  
  const handleCancel = () => setIsModalOpen(false);
  
  const handleOk = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    EventEmitter.subscribe('openSellOrDisposeModal', data => setIsModalOpen(data));
    return () => EventEmitter.unsubscribe('openSellOrDisposeModal');
  },[])

  const handleSell = () => {
    EventEmitter.dispatch('sell_asset', 'done');
    handleCancel();
  }

  return (
    <Modal title="Sell or Dispose Asset" className='p-0' open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSell={handleSell}/>}>
      <Form name="sellDispose"
        form={form}
        className='border-t-2 pt-2' 
        labelAlign='left'
        labelCol={{span: 8}}
        initialValues={{  }}
        autoComplete="off"
        variant='borderless'
      >
        <Form.Item label='Action' name="action" className='font-semibold text-gray-800 mb-4' required>
          <Select options={action} />
        </Form.Item>
        <Form.Item label='Customer Invoice' name="customer_invoice" className='font-semibold text-gray-800 mb-4' required>
          <Select options={[]} />
        </Form.Item>
        <Form.Item label='Loss Account' name="loss_account" className='font-semibold text-gray-800 mb-4' required>
          <Select options={[]} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SellOrDispose;